import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { ERouterName } from '/@/types/index'

const WaylinePanel = () => import('/@/pages/page-web/projects/wayline.vue')
const CreatePlan = () => import('/@/components/task/CreatePlan.vue')
const DockPanel = () => import('/@/pages/page-web/projects/dock.vue')
const LiveAgora = () => import('/@/components/livestream-agora.vue')
const LiveOthers = () => import('/@/components/livestream-others.vue')

// 静态路由
export const constantRoutes: Array<RouteRecordRaw> = [
  {
    path: '/404',
    name: '404',
    component: () => import('/@/pages/page-web/404.vue')
  },
  {
    path: '/',
    redirect: '/' + ERouterName.PROJECT
  },
  // 登录
  {
    path: '/' + ERouterName.PROJECT,
    name: ERouterName.PROJECT,
    component: () => import('/@/pages/page-web/index.vue')
  },
  // 免登录
  // {
  //   path: '/' + ERouterName.FREE_LOGIN,
  //   name: ERouterName.FREE_LOGIN,
  //   component: () => import('/@/pages/page-web/freeLogin.vue')
  // },
  // 大屏
  {
    path: '/' + ERouterName.LARGE_SCREEN,
    name: ERouterName.LARGE_SCREEN,
    component: () => import('/@/pages/page-web/largeScreen.vue')

  },
  // pilot
  {
    path: '/' + ERouterName.PILOT,
    name: ERouterName.PILOT,
    component: () => import('/@/pages/page-pilot/pilot-index.vue'),
  },
  {
    path: '/' + ERouterName.PILOT_HOME,
    component: () => import('/@/pages/page-pilot/pilot-home.vue')
  },
  {
    path: '/' + ERouterName.PILOT_MEDIA,
    component: () => import('/@/pages/page-pilot/pilot-media.vue')
  },
  {
    path: '/' + ERouterName.PILOT_LIVESHARE,
    component: () => import('/@/pages/page-pilot/pilot-liveshare.vue')
  },
  {
    path: '/' + ERouterName.PILOT_BIND,
    component: () => import('/@/pages/page-pilot/pilot-bind.vue')
  },
  {
    path: '/blackFly',
    component: () => import('/@/pages/page-web/blackFly.vue')
  }
]

/**
 * 创建路由
 */
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: constantRoutes,
  // 刷新时，滚动条位置还原
  scrollBehavior: () => ({ left: 0, top: 0 }),
})

/**
 * 重置路由
 */
export function resetRouter () {
  router.replace({ path: `/${ERouterName.PROJECT}` })
}

export default router
